import { render, staticRenderFns } from "./ArrowButton.vue?vue&type=template&id=3cee5b44"
import script from "./ArrowButton.vue?vue&type=script&lang=js"
export * from "./ArrowButton.vue?vue&type=script&lang=js"
import style0 from "./ArrowButton.vue?vue&type=style&index=0&id=3cee5b44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports